"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _Flex = require("./Flex.styled");
var _jsxRuntime = require("react/jsx-runtime");
var FlexItem = function FlexItem(_ref) {
  var children = _ref.children,
    flexBasis = _ref.flexBasis,
    alignSelf = _ref.alignSelf,
    dataCy = _ref['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.ItemContainer, {
    flexBasis: flexBasis,
    alignSelf: alignSelf,
    "data-cy": dataCy,
    children: children
  });
};
exports.FlexItem = FlexItem;